module.exports = __webpack_public_path__ + "img/delano9.6178f6e9.jpg";